import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Avatar,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Booking.scss";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import GroupIcon from "@mui/icons-material/Group";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PercentIcon from "@mui/icons-material/Percent";
import {
  BOOKING_PASSENGER_DETAILS,
  COMPLEMENTARY_SUCCESS_PAGE,
  DEV_PAYMENT_PROCESSING,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
  SUCCESS_PAGE,
} from "../../component/common/Routes/AppRoutes";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_SUCCESS_PAGE,
} from "../../component/common/Routes/CustomerRoutes";
import {
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_SUCCESS_PAGE,
} from "../../component/common/Routes/VendorRoutes";
import {
  addBookingRequest,
  resetBookingDetails,
} from "../../redux/Bookings/BookingAction";
import { toast, ToastContainer } from "react-toastify";
import CustomButton from "../../component/ui/FormFields/Button";
import ControlledTextInputField from "../../component/ui/FormFields/ControlledTextInputField";
import { Controller, useForm } from "react-hook-form";
import { fetchVendorDetailsRequest } from "../../redux/Vendors/actions/vendorActions";

import { convertDateFormat, convertDateFormatBooking } from "../../Style";

import AirportDetailsTable from "../UnAuthBooking/AirportDetailsTable";
import PassengerTable from "./PassengerTable";
import {
  resetValidatePromoCode,
  validatePromoCodeRequest,
} from "../../redux/PromoCode/PromoCodeAction";
import PulseLoader from "react-spinners/PulseLoader";

const BookingInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const [remarks, setRemarks] = useState("");
  const booking = useSelector((state) => state?.booking);
  const dispatch = useDispatch();
  const [showDiscount, setShowDiscount] = useState(false);
  const [showChildDiscount, setShowChildDiscount] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromoCode, setAppliedPromoCode] = useState("");
  const [promoDiscount, setPromoDiscount] = useState(0);
  const form1Value = location.state?.form1Value || {};

  const validPromoLoading = useSelector(
    (state) => state.promoCode.promoCodeValidation.loading
  );
  const validPromoSuccess = useSelector(
    (state) => state.promoCode.promoCodeValidation.success
  );

  const validPromoError = useSelector(
    (state) => state.promoCode.promoCodeValidation.error
  );

  const paymentUrl = booking?.data?.payment_url;
  const pnrNumber = booking?.data?.MemberInfo?.pnr_number;
  const form2Value = location.state?.form2Value || {};
  const form3Value = location.state?.form3Value || {};
  const vendorDetailsState = useSelector(
    (state) => state.vendors.vendorDetails
  );

  const vendorDetails = vendorDetailsState?.data || {};

  const servicePlan =
    form1Value?.arrival_plan !== ""
      ? form1Value?.arrival_plan?.label
      : form1Value?.departure_plan !== ""
        ? form1Value?.departure_plan?.label
        : form1Value?.transit_plan !== ""
          ? form1Value?.transit_plan?.label
          : "-";

  const {
    control,
    formState: { errors },
    watch,
    setError,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      discount: form3Value?.discount || 0,
      gst_number: form3Value?.gst_number || "-",
      childDiscount: form3Value?.childDiscount || 0,
      applyDiscount: form3Value?.applyDiscount || false,
      applyComplementary: form3Value?.applyComplementary || false,
      applyChildDiscount: form3Value?.applyChildDiscount || false,
    },
    mode: "onChange",
  });

  const formValue = watch();

  const isError = Object.keys(errors).length > 0;
  const service = form1Value?.arrival_departure_type?.value || "";
  useEffect(() => {
    setShowDiscount(formValue?.applyDiscount || false);
    setShowChildDiscount(formValue?.applyChildDiscount || false);
  }, [formValue?.applyDiscount, formValue?.applyChildDiscount]);

  const errorMessage = booking?.error;
  const loading = booking?.loading;
  useEffect(() => {
    if (errorMessage) {
      toast.error("Failed to add booking", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
        },
      });
    }
  }, [errorMessage]);

  const adultFamilyMember = form2Value?.family_members?.filter((adult) => {
    return adult?.age >= 12;
  });

  const infantFamilyMember = form2Value?.family_members?.filter((infant) => {
    return infant?.age < 2;
  });
  const childFamilyMember = form2Value?.family_members?.filter((child) => {
    return child?.age >= 2 && child?.age < 12;
  });

  const adultDiscount = adultFamilyMember?.[0]?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.discount || 0;
  const infantDiscount = infantFamilyMember?.[0]?.discount || 0;

  const adult = adultFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });
  const child = childFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });
  const infant = infantFamilyMember?.map((value) => {
    return {
      id: value?.id,
      passport_number: value?.aadhar_number || null,
      aadhar_number: value?.aadhar_number || null,
    };
  });

  const familyMember = [...(adult || []), ...(infant || []), ...(child || [])];
  const servicePlans = [
    form1Value?.arrival_plan?.label,
    form1Value?.departure_plan?.label,
    form1Value?.transit_plan?.label,
  ];
  const isPorterService = servicePlans?.some((service) =>
    service?.toLowerCase().includes("porter")
  );
  const bookingValue = {
    customer_id:
      user.customer_id ||
      form2Value?.customer_id ||
      form1Value?.customerDetails?.id ||
      "-",
    first_name: " ",
    last_name: " ",
    email: "",
    display_name: "",
    phone: " ",
    country_code: "",
    airport_id: form1Value?.airport?.value || "-",
    airport_type:
      form1Value?.service_type === "Domestic"
        ? "1"
        : form1Value?.service_type === "International"
          ? "2"
          : "3",
    type_of_class: form1Value?.type_of_class?.value,

    service_type:
      form1Value?.arrival_departure_type?.value === "Arrival"
        ? "1"
        : form1Value?.arrival_departure_type?.value === "Departure"
          ? "2"
          : "3" || "-",
    service_id:
      form1Value?.arrival_plan?.value ||
      form1Value?.departure_plan?.value ||
      form1Value?.transit_plan?.value ||
      "-",
    number_of_adults: form2Value?.no_of_adult || "0",
    number_of_child: form2Value?.no_of_child || "0",
    number_of_infant: form2Value?.no_of_infant || "0",
    date_of_departure:
      convertDateFormatBooking(form1Value?.departure_date) || null,
    time_of_departure: form1Value?.departure_time || null,
    departure_airlines: form1Value?.departure_airline || "-",
    arrival_from_city: form1Value?.arrival_city || "-",
    departure_from_city: form1Value?.departure_city || "-",
    departure_flight_number: form1Value?.departure_flight_number || "-",
    arival_pnr_by_customer: form1Value?.arival_pnr_by_customer || "-",
    departure_pnr_by_customer: form1Value?.departure_pnr_by_customer || "-",
    arrival_airlines: form1Value?.arrival_airline || "-",
    time_of_arrival: form1Value?.arrival_time || null,
    date_of_arrival: convertDateFormatBooking(form1Value?.arrival_date) || null,
    total_passengers: form2Value?.total_passengers || "0",
    notes: form2Value?.notes || "-",
    address_id: form2Value.billing_address || "-",
    arrival_flight_number: form1Value?.arrival_flight_number || "-",
    number_of_service: form2Value?.total_services || "-",
    familymembers: familyMember || "-",
    proof_url: null,
    gender_type: "M",
    vendor_gst_number: formValue.gst_number,
    discount: formValue?.discount || 0,
    booked_type: formValue?.applyComplementary ? 2 : 1,
    vendor_gst_number: formValue?.gst_number || "-",
    remarks: remarks || "",
    success_url: DEV_PAYMENT_PROCESSING,
    failure_url: DEV_PAYMENT_PROCESSING,
    booked_service: isPorterService ? "2" : "1",
    is_mobile: 1,
    promocode_id: validPromoSuccess?.data?.id || "", // Add promo code to booking data
  };

  const submitBookingData = () => {
    dispatch(addBookingRequest(bookingValue));
  };

  // Handle promo code application
  const handleApplyPromoCode = () => {
    dispatch(
      validatePromoCodeRequest({
        promocode: promoCode,
        service_id: bookingValue.service_id,
        applicable_platform: 1,
      })
    );
  };

  const handleRemovePromoCode = () => {
    setAppliedPromoCode("");
    setPromoDiscount(0);
    setPromoCode("");
    dispatch(resetValidatePromoCode());
  };

  const bookingData = [
    {
      icon: <GroupIcon className="passenger-icon" />,
      title: "Passenger Details",
      fields: [
        { label: "No. of Adults", value: form2Value.no_of_adult || 0 },
        { label: "No. of Children", value: form2Value.no_of_child || 0 },
        { label: "No. of Infants", value: form2Value.no_of_infant || 0 },
        { label: "Total Passengers", value: form2Value.total_passengers || 0 },
      ],
    },
    {
      icon: <FlightTakeoffIcon className="service-icon" />,
      title: "Service Details",

      fields: [
        { label: "Service", value: servicePlan || "-" },
        { label: "Arrival/Departure", value: service || "-" },
        { label: "Service Type", value: form1Value.service_type.value || "-" },

        {
          label: "Number of Services",
          value: parseInt(form2Value.total_services) || "0",
        },
      ],
    },
    {
      icon: <LocationOnIcon className="location-icon" />,
      title: "Airport Details",
      fields:
        service === "Arrival"
          ? [
            {
              label: "Travel class",
              value: form1Value.type_of_class.label || "-",
            },
            { label: "Airport", value: form1Value.airport.label || "" },
            {
              label: "Arrival Date & Time",

              value:
                `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                "",
            },
            {
              label: "Arrival Flight Number",
              value: form1Value.arrival_flight_number || "",
            },
            {
              label: "Arrival PNR Number",
              value: form1Value.arival_pnr_by_customer || "",
            },
            {
              label: "Arrival Airline",
              value: form1Value.arrival_airline || "",
            },
          ]
          : service === "Departure"
            ? [
              {
                label: "Travel class",
                value: form1Value.type_of_class.label || "-",
              },
              { label: "Airport", value: form1Value.airport.label || "-" },
              {
                label: "Departure Date & Time",
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  "",
              },
              {
                label: "Departure Flight Number",
                value: form1Value.departure_flight_number || "-",
              },
              {
                label: "Departure PNR Number",
                value: form1Value.departure_pnr_by_customer || "-",
              },
              {
                label: "Departure Airline",
                value: form1Value.departure_airline || "-",
              },
            ]
            : [
              {
                label: "Travel class",
                value: form1Value.type_of_class.label || "-",
              },
              { label: "Airport", value: form1Value.airport.label || "-" },
              {
                label: "Arrival Date & Time",
                value:
                  `${form1Value.arrival_date} - ${form1Value.arrival_time} ` ||
                  "",
              },
              {
                label: "Arrival Flight Number",
                value: form1Value.arrival_flight_number || "-",
              },
              {
                label: "Arrival PNR Number",
                value: form1Value.arival_pnr_by_customer || "-",
              },
              {
                label: "Arrival Airline",
                value: form1Value.arrival_airline || "-",
              },

              {
                label: "Departure Date & Time",
                value:
                  `${form1Value.departure_date} - ${form1Value.departure_time} ` ||
                  "",
              },
              {
                label: "Departure Flight Number",
                value: form1Value.departure_flight_number || "-",
              },
              {
                label: "Departure PNR Number",
                value: form1Value.departure_pnr_by_customer || "-",
              },
              {
                label: "Departure Airline",
                value: form1Value.departure_airline || "-",
              },
            ],
    },
  ];

  useEffect(() => {
    if (
      paymentUrl &&
      bookingValue?.booked_type === 1 &&
      user?.role !== "Admin" &&
      user?.role !== "Staff"
    ) {
      //  window.location.href = paymentUrl;
      handleRemovePromoCode();
      window.open(paymentUrl, "_blank");

      toast.success("The payment link has been shared successfully.", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {

          dispatch(resetBookingDetails());
        },
      });
    }
    if (
      paymentUrl &&
      bookingValue?.booked_type === 1 &&
      (user?.role === "Admin" || user?.role === "Staff")
    ) {
      handleRemovePromoCode();
      navigate(SUCCESS_PAGE, {
        state: {
          pnr_number: pnrNumber,
        },
      });
    }
    if (bookingValue?.booked_type === 2 && pnrNumber) {
      navigate(COMPLEMENTARY_SUCCESS_PAGE, {
        state: {
          pnr_number: pnrNumber,
        },
      });
    }
  }, [paymentUrl, pnrNumber]);

  useEffect(() => {
    if (validPromoError) {
      setTimeout(() => {
        dispatch(resetValidatePromoCode());
      }, 5000);
    }
    if (validPromoSuccess) {
      setPromoDiscount(
        validPromoSuccess?.data?.discount_type == 1
          ? validPromoSuccess?.data?.discount_percent
          : validPromoSuccess?.data?.discount_value
      );
      setAppliedPromoCode(validPromoSuccess?.data?.discount_code);
    }
  }, [validPromoError, validPromoSuccess]);
  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

  const no_of_child_after_discount =
    childDiscount > 0
      ? (childFamilyMember.length * childDiscount) / 100
      : childFamilyMember.length;

  const Gross_Total_Service = form2Value.total_services;
  const no_of_service = isPorterService
    ? parseInt(form2Value.total_services)
    : parseInt(form2Value.total_services) - no_of_child_after_discount;
  const servicePrice = form1Value.servicePlanPrice;

  const vendorCommission =
    user?.user_type === 2
      ? -(
        parseFloat(no_of_service * servicePrice) *
        (vendorDetails?.discount / 100)
      ) || 0
      : 0;

  // Discount Calculation
  const [discountAmout, setDiscountAmount] = useState(0);
  const [childDiscountAmount, setChildDiscountAmount] = useState(0);
  const [promoDiscountAmount, setPromoDiscountAmount] = useState(0);

  const discountValue = formValue?.discount;
  const childDiscountValue = formValue?.childDiscount;
  const childPrice =
    childFamilyMember?.length * servicePrice -
    childFamilyMember?.length * (childDiscount / 100) * servicePrice;
  const childDiscountedPrices = (customDiscountValue) => {
    if (childDiscount > 100) {
      setError("childDiscount", { message: "Enter Between 0-100 %" });
    } else {
      const newChildDiscountValue =
        customDiscountValue >= 0 ? customDiscountValue : childDiscountValue;
      clearErrors("childDiscount");

      setChildDiscountAmount(childPrice * (newChildDiscountValue / 100));
      setDiscountAmount(0);
      setValue("discount", 0);
    }
  };
  const discountedPrices = (customDiscountValue) => {
    if (discountValue > 100) {
      setError("discount", { message: "Enter Between 0-100 %" });
    } else {
      const subTotalForDiscount =
        parseFloat(no_of_service * servicePrice) -
        (vendorCommission || 0) -
        childDiscountAmount || 0;
      const newDiscountValue =
        customDiscountValue >= 0 ? customDiscountValue : discountValue;
      clearErrors("discount");

      setDiscountAmount(subTotalForDiscount * (newDiscountValue / 100));
    }
  };

  // Calculate promo discount amount
  useEffect(() => {
    if (promoDiscount > 0) {
      const subTotalForPromo =
        parseFloat(no_of_service * servicePrice) -
        (vendorCommission || 0) -
        (childDiscountAmount || 0) -
        (discountAmout || 0);

      if (validPromoSuccess?.data?.discount_type == 2) {
        // Flat amount discount
        setPromoDiscountAmount(promoDiscount);
      } else {
        // Percentage discount
        setPromoDiscountAmount(subTotalForPromo * (promoDiscount / 100));
      }
    } else {
      setPromoDiscountAmount(0);
    }
  }, [
    promoDiscount,
    no_of_service,
    servicePrice,
    vendorCommission,
    childDiscountAmount,
    discountAmout,
  ]);

  const subTotal =
    parseFloat(no_of_service * servicePrice) -
    ((parseFloat(discountAmout) || 0) - (vendorCommission || 0)) -
    childDiscountAmount -
    promoDiscountAmount || 0;

  const orderSummary = {
    totals: [
      form1Value?.servicePlanPrice && {
        label: "Gross Amount",
        value: 0,
        formattedValue: currencyFormatter.format(
          parseFloat(Gross_Total_Service * servicePrice) || 0
        ),
      },

      adultFamilyMember?.length > 0 &&
      !isPorterService && {
        label: `Adult Discount(${adultDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(
            adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      childFamilyMember?.length > 0 &&
      !isPorterService && {
        label: `Child Discount(${childDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter?.format(
          -parseFloat(
            childFamilyMember?.length * (childDiscount / 100) * servicePrice
          ) || 0
        ),
      },
      // (infantFamilyMember?.length > 0&&!isPorterService) && {
      //   label: `Infant Discount(${infantDiscount}%)`,
      //   value: 0,
      //   formattedValue: currencyFormatter.format(
      //     -parseFloat(
      //       infantFamilyMember?.length * (infantDiscount / 100) * servicePrice
      //     ) || 0
      //   ),
      // },
      vendorCommission !== 0 &&
      user?.user_type === 2 && {
        label: `Vendor Commission (${vendorDetails?.discount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(vendorCommission || 0),
      },
      // formValue?.childDiscount >= 0 &&
      //   childFamilyMember?.length > 0 &&
      //   (user?.user_type === 1 || user?.user_type === 4) && {
      //     label: `Child Complementary(${formValue?.childDiscount}%)`,
      //     value: 0,
      //     formattedValue: currencyFormatter.format(
      //       -parseFloat(childFamilyMember?.length * childDiscountAmount) || 0
      //     ),
      //   },
      formValue?.discount >= 0 &&
      user?.user_type !== 2 &&
      user?.user_type !== 3 && {
        label: `Booking Discount(${formValue?.discount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(discountAmout) || 0
        ),
      },
      promoDiscount > 0 && {
        label: `Promo Code Discount (${appliedPromoCode} - ${validPromoSuccess?.data?.discount_type == 2
          ? `₹${promoDiscount}`
          : `${promoDiscount}%`
          })`,
        value: 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(promoDiscountAmount) || 0
        ),
      },
      form1Value?.servicePlanPrice && {
        label: "SubTotal",
        value: parseFloat(subTotal?.toFixed(2)),

        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) || 0
        ),
      },

      form1Value?.tax > 0 && {
        label: `IGST (${form1Value?.tax_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.tax_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.tax_percentage) / 100) || 0
        ),
      },
      form1Value?.sgst > 0 && {
        label: `SGST (${form1Value?.sgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.sgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.sgst_percentage) / 100) || 0
        ),
      },
      form1Value?.cgst > 0 && {
        label: `CGST (${form1Value?.cgst_percentage}%)`,
        value:
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.cgst_percentage) / 100) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(subTotal?.toFixed(2)) *
          (parseFloat(form1Value.cgst_percentage) / 100) || 0
        ),
      },
    ].filter(Boolean),
  }; // Ensure form1Value properties are valid numbers

  const totalAmount = orderSummary.totals.reduce(
    (sum, item) => sum + item.value,
    0
  );

  const formattedTotalAmount = currencyFormatter.format(totalAmount);

  useEffect(() => {
    discountedPrices();
    if (user?.user_type === 2) {
      dispatch(fetchVendorDetailsRequest(user?.vendor_id));
    }
  }, []);

  const updateComplementaryValue = async (isChecked) => {
    if (isChecked) {
      setValue("applyDiscount", false);
      setValue("applyChildDiscount", false);
      setValue("discount", 0);
      setValue("childDiscount", 0);
      discountedPrices(0);
      childDiscountedPrices(0);
      // Remove promo code when complementary is applied
      if (appliedPromoCode) {
        handleRemovePromoCode();
      }
    } else {
      setValue("applyComplementary", false);
    }
  };

  const updateDiscountValues = async (isChecked) => {
    if (isChecked) {
      setValue("applyComplementary", false);
    } else {
      setValue("applyDiscount", false);
      setValue("discount", 0);
      discountedPrices(0);
    }
  };
  const updateChildDiscountValues = async (isChecked) => {
    if (isChecked) {
      setValue("applyComplementary", false);
    } else {
      setValue("applyChildDiscount", false);
      setValue("childDiscount", 0);
      childDiscountedPrices(0);
    }
  };

  // for select
  // Render fields dynamically
  const renderFields = (fields) =>
    fields.map((item, index) => (
      <Box key={index} className="label-value-container">
        <Typography variant="body1" className="label-style">
          {item.label}
        </Typography>
        <Typography variant="body1" className="value-style">
          {item.value}
        </Typography>
      </Box>
    ));
  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  return (
    <>
      <ToastContainer />
      <Box className="booking-summary-body">
        <Grid container spacing={4}>
          {/* Passenger Details (First Box) */}
          {bookingData[0] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={6} // One-third width on 1440px and above
              key="row1-box1"
            >
              <Paper elevation={4} className="booking-summary-paper">
                <Box className="booking-summary-content-box">
                  <Box className="booking-heading-alignment">
                    <Avatar className="booking-summary-avatar-style">
                      {bookingData[0].icon}
                    </Avatar>
                    <Typography
                      variant="h6"
                      className="booking-summary-title-style"
                    >
                      {bookingData[0].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: "10px 0",
                      borderColor: "#ddd",
                      width: "100%",
                    }}
                  />
                </Box>
                {renderFields(bookingData[0].fields)}
              </Paper>
            </Grid>
          )}
          {/* Booking Details (Second Box) */}
          {bookingData[1] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={6} // One-third width on 1440px and above
              key="row1-box2"
            >
              <Paper elevation={4} className="booking-summary-paper">
                <Box className="booking-summary-content-box">
                  <Box className="booking-heading-alignment">
                    <Avatar className="booking-summary-avatar-style">
                      {bookingData[1].icon}
                    </Avatar>
                    <Typography
                      variant="h6"
                      className="booking-summary-title-style"
                    >
                      {bookingData[1].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: "10px 0",
                      borderColor: "#ddd",
                      width: "100%",
                    }}
                  />
                </Box>
                {renderFields(bookingData[1].fields)}
              </Paper>
            </Grid>
          )}
          {/* Passenger Information */}
          <Grid item xs={12}>
            <PassengerTable form2Value={form2Value} />
          </Grid>
          {/* Airport Details (Third Box) */}
          {bookingData[2] && (
            <Grid item xs={12} md={6} xl={6} key="row1-box3">
              <AirportDetailsTable form1Value={form1Value} />
            </Grid>
          )}

          {/* Order Summary */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className="unauth-booking-summary-order-paper">
              <Box className="booking-summary-order-box">
                <Avatar className="booking-summary-order-avatar">
                  <ReceiptIcon className="booking-summary-receipticon" />
                </Avatar>
                <Typography
                  variant="h6"
                  className="booking-summary-title-style"
                >
                  Order Summary
                </Typography>
              </Box>
              <Divider className="booking-summary-divider" />

              {orderSummary.totals.map((item, index) => (
                <Box key={index} className="booking-summary-order-content">
                  <Typography
                    variant="body1"
                    className="booking-summary-total-label"
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    className="booking-summary-total-value"
                  >
                    {item.formattedValue}
                  </Typography>
                </Box>
              ))}
              <Divider className="booking-summary-divider" />
              <Box
                className="booking-summary-order-content"
                sx={{ paddingBottom: "20px" }}
              >
                <Typography
                  variant="h6"
                  className="booking-summary-total-label"
                >
                  Total
                </Typography>
                <Typography
                  variant="h6"
                  className="booking-summary-total-value"
                >
                  {formattedTotalAmount}
                </Typography>
              </Box>
            </Paper>
          </Grid>
          {(user.role === "Admin" || user.role === "Staff") && (
            <Grid item xs={12} md={12}>
              <Paper
                elevation={4}
                sx={{ borderRadius: "12px", padding: "10px" }}
              >
                <Box className="booking-summary-order-box">
                  <Avatar className="booking-summary-order-avatar">
                    <LocalOfferIcon className="booking-summary-offer" />
                  </Avatar>
                  <Typography
                    variant="h6"
                    className="booking-summary-title-style"
                  >
                    Offers
                  </Typography>
                </Box>
                <Divider className="booking-summary-divider" />

                <Box gap={2}>
                  <Grid container spacing={4}>
                    {/* Apply Complementary and Promo Code side by side */}
                    <Grid
                      item
                      xs={12}
                      sx={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      {/* Apply Complementary Checkbox */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", flex: 1 }}
                      >
                        <Controller
                          name="applyComplementary"
                          control={control}
                          render={({ field: { onChange, ...field } }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) => {
                                    onChange(e);
                                    updateComplementaryValue(e.target.checked);
                                  }}
                                />
                              }
                              label="Apply Complementary"
                            />
                          )}
                        />
                      </Box>

                      {/* Promo Code Section - Side by side */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flex: 2,
                          gap: 2,
                        }}
                      >
                        <Typography variant="body1" sx={{ minWidth: "100px" }}>
                          Promo Code:
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            maxWidth: "400px",
                          }}
                        >
                          <TextField
                            size="small"
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                            placeholder="Enter promo code"
                            disabled={!!appliedPromoCode}
                          />

                          {/* Error message below input */}
                          {validPromoError && (
                            <Typography
                              variant="body2"
                              color="error"
                              sx={{ mt: "4px", fontSize: "0.8rem" }}
                            >
                              {validPromoError}
                            </Typography>
                          )}
                          {appliedPromoCode && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "10px",
                                gap: 1,
                              }}
                            >
                              <Typography variant="body2" color="success.main">
                                Applied: {appliedPromoCode} (
                                {validPromoSuccess?.data?.discount_type == 2
                                  ? `${promoDiscount} Rupee`
                                  : `${promoDiscount} Percent`}
                                )
                              </Typography>
                              <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                onClick={handleRemovePromoCode}
                              >
                                Remove
                              </Button>
                            </Box>
                          )}
                        </Box>
                        {!appliedPromoCode && (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={handleApplyPromoCode}
                            disabled={!promoCode.trim()}
                            sx={{
                              minWidth: "80px",
                              color: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "8px",
                              backgroundColor: "#ed6c02",
                            }}
                          >
                            {validPromoLoading ? (
                              <PulseLoader color={"#fff"} size={8} />
                            ) : (
                              "Apply"
                            )}
                          </Button>
                        )}
                      </Box>
                    </Grid>

                    {/* {childFamilyMember?.length > 0 && (
            <Grid item xs={12} sx={{ display: 'flex', gap: 5 }}>
              <Grid item xs={4}>
                <Controller
                  name='applyChildDiscount'
                  control={control}
                  render={({ field: { onChange, ...field } }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value}
                          onChange={(e) => {
                            onChange(e);
                            updateChildDiscountValues(
                              e.target.checked
                            );
                          }}
                        />
                      }
                      label='Child Complementary'
                    />
                  )}
                />
              </Grid>
              {showChildDiscount && (
                <Grid item xs={6}>
                  <ControlledTextInputField
                    name={'childDiscount'}
                    control={control}
                    rules={{
                      pattern: {
                        value:
                          /^(100(\.00?)?|[0-9]{1,2}(\.\d{1,2})?)$/,
                        message: 'Enter a number between 0 and 100 %',
                      },
                    }}
                    size={'small'}
                    type={'number'}
                    label={'Discount %'}
                    placeholder={'Enter Discount'}
                    error={!!errors['childDiscount']}
                    helperText={errors['childDiscount']?.message}
                  />
                </Grid>
              )}
              {showChildDiscount && (
                <Grid item xs={2}>
                  <CustomButton
                    variant='contained'
                    className='success-button'
                    type='button'
                    onClick={() => {
                      childDiscountedPrices();
                    }}
                    text='Apply'
                  />
                </Grid>
              )}
            </Grid>
          )} */}

                    <Grid item xs={12} sx={{ display: "flex", gap: 5 }}>
                      <Grid item xs={4}>
                        <Controller
                          name="applyDiscount"
                          control={control}
                          render={({ field: { onChange, ...field } }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  checked={field.value}
                                  onChange={(e) => {
                                    onChange(e);
                                    updateDiscountValues(e.target.checked);
                                  }}
                                />
                              }
                              label="Apply Discount"
                            />
                          )}
                        />
                      </Grid>
                      {showDiscount && (
                        <Grid item xs={6}>
                          <ControlledTextInputField
                            name={"discount"}
                            control={control}
                            rules={{
                              pattern: {
                                value: /^(100(\.00?)?|[0-9]{1,2}(\.\d{1,2})?)$/,
                                message: "Enter a number between 0 and 100 %",
                              },
                            }}
                            size={"small"}
                            type={"number"}
                            label={"Discount %"}
                            placeholder={"Enter Discount"}
                            error={!!errors["discount"]}
                            helperText={errors["discount"]?.message}
                          />
                        </Grid>
                      )}

                      {showDiscount && (
                        <Grid item xs={2}>
                          <CustomButton
                            variant="contained"
                            className="success-button"
                            type="button"
                            onClick={() => {
                              discountedPrices();
                            }}
                            text="Apply"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          )}

          {(user.role === "Admin" || user.role === "Staff") && (
            <Grid item xs={12} md={12}>
              <Paper
                elevation={4}
                sx={{ borderRadius: "12px", padding: "10px", px: 3 }}
              >
                <Box sx={{ mb: 3, mt: 2 }}>
                  <Box sx={{ mt: 3 }}>
                    <ControlledTextInputField
                      name={"gst_number"}
                      control={control}
                      size={"small"}
                      type={"text"}
                      rules={{
                        pattern: {
                          value:
                            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                          message:
                            "Invalid GST Number format eg (27AAAPA1234A1Z5)",
                        },
                      }}
                      label={"GST Number"}
                      placeholder={"Enter GST Number"}
                      error={!!errors["gst_number"]}
                      helperText={errors["gst_number"]?.message}
                    />
                  </Box>
                  <Typography variant="subtitle1" sx={{ mb: 1, mt: 3 }}>
                    Remarks
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    placeholder="Enter remarks here..."
                    value={remarks}
                    onChange={handleRemarksChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "4px",
                        backgroundColor: "#ffffff",
                      },
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          )}

          {(user.role === "Vendor" || user.role === "Customer") && (
            <Grid item xs={12} md={12}>
              <Paper
                elevation={4}
                sx={{ borderRadius: "12px", padding: "10px", px: 3 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 4,
                    flexWrap: "wrap",
                  }}
                >
                  {/* Promo Code Section */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flex: 2,
                      gap: 2,
                    }}
                  >
                    <Typography variant="body1" sx={{ minWidth: "100px" }}>
                      Promo Code:
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        maxWidth: "400px",
                      }}
                    >
                      <TextField
                        size="small"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value)}
                        placeholder="Enter promo code"
                        disabled={!!appliedPromoCode}
                      />

                      {/* Error message below input */}
                      {validPromoError && (
                        <Typography
                          variant="body2"
                          color="error"
                          sx={{ mt: "4px", fontSize: "0.8rem" }}
                        >
                          {validPromoError}
                        </Typography>
                      )}
                      {appliedPromoCode && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            gap: 1,
                          }}
                        >
                          <Typography variant="body2" color="success.main">
                            Applied: {appliedPromoCode} (
                            {validPromoSuccess?.data?.discount_type == 2
                              ? `${promoDiscount} Rupee`
                              : `${promoDiscount} Percent`}
                            )
                          </Typography>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={handleRemovePromoCode}
                          >
                            Remove
                          </Button>
                        </Box>
                      )}
                    </Box>
                    {!appliedPromoCode && (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleApplyPromoCode}
                        disabled={!promoCode.trim()}
                        sx={{
                          minWidth: "80px",
                          color: "white",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "8px",
                          backgroundColor: "#ed6c02",
                        }}
                      >
                        {validPromoLoading ? (
                          <PulseLoader color={"#fff"} size={8} />
                        ) : (
                          "Apply"
                        )}
                      </Button>
                    )}
                  </Box>

                  {/* GST Number Section */}
                  <Box sx={{ flex: 1, minWidth: "300px" }}>
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, fontSize: "1rem", fontWeight: "bold" }}
                    >
                      GST Information
                    </Typography>
                    <ControlledTextInputField
                      name={"gst_number"}
                      control={control}
                      size={"small"}
                      type={"text"}
                      rules={{
                        pattern: {
                          value:
                            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                          message:
                            "Invalid GST Number format eg (27AAAPA1234A1Z5)",
                        },
                      }}
                      label={"GST Number"}
                      placeholder={"Enter GST Number"}
                      error={!!errors["gst_number"]}
                      helperText={errors["gst_number"]?.message}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          )}
          {/* Next Button */}
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          // className='button-container'
          >
            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                className="grey-button"
                onClick={() => {
                  let passengerDetailsRoute;

                  if (user.role === "Admin" || user.role === "Staff") {
                    passengerDetailsRoute = BOOKING_PASSENGER_DETAILS;
                  } else if (user.role === "Vendor") {
                    passengerDetailsRoute = VENDOR_BOOKING_PASSENGER_DETAILS;
                  } else if (user.role === "Customer") {
                    passengerDetailsRoute = CUSTOMER_BOOKING_PASSENGER_DETAILS;
                  }
                  navigate(passengerDetailsRoute, {
                    state: {
                      form1Value: form1Value,
                      form2Value: form2Value,
                      form3Value: formValue,
                    },
                  });
                }}
              >
                Back
              </Button>

              <CustomButton
                variant="contained"
                className="orange-button"
                onClick={submitBookingData}
                disabled={isError}
                loading={loading}
                text={formValue?.applyComplementary ? "Complmentary" : "Pay"}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default BookingInvoice;
